export { WaitingText } from "./WaitingText"
export type { WaitingTextProps } from "./WaitingText"
